module.exports = __webpack_public_path__ + "img/fintech-awards-2020.59a4412f.jpg";